import {
	Container,
	ContainerGutter,
	styled,
	Text,
	TextAlignment,
	TokenTextAppearance,
	TokenTextColor,
} from '@volkswagen-onehub/components-core';
import React from 'react';
import { HuchaVentaValues } from '../../../../shared/models/hucha-values';
import { LogoHuchaVenta2Lines } from '../../../assets/logo-hucha-venta-2lines';
import { LogoHuchaVenta3Lines } from '../../../assets/logo-hucha-venta-3lines';
import { HuchaStandardButtons } from '../../ui/hucha-venta-standard-buttons';

const AlignedContainer = styled.div`
	display: flex;
	flex-direction: column;
	width: fit-content;
	gap: 20px;
`;

export const HuchaStandardCardC1 = ({ huchaValues }: { huchaValues: HuchaVentaValues }) => {
	return (
		<Container data-testid="card-c1-container" gutter={ContainerGutter.static200} stretchContent wrap="always">
			<div>
				<LogoHuchaVenta2Lines className="card-c1-logo-2l" />
				<LogoHuchaVenta3Lines className="card-c1-logo-3l" />
			</div>
			<AlignedContainer>
				<Text
					appearance={TokenTextAppearance.headline100}
					color={TokenTextColor.inverted}
					textAlign={TextAlignment.left}
					bold
				>
					{'Cada mes, acumulas 10€ para tu próximo Volkswagen'}
				</Text>
				<HuchaStandardButtons dataTestId="card-c1-buttons" huchaValues={huchaValues} />
			</AlignedContainer>
		</Container>
	);
};
